import {
  DropdownAiOption,
  DropdownAiSection,
  DropdownButtonOption,
  DropdownCustomContentOption,
  DropdownDivider,
  DropdownExpandableSection,
  DropdownHeader,
  DropdownHeaderWithIconButton,
  DropdownItem,
  DropdownLink,
  DropdownMessage,
  DropdownOption,
  DropdownOptionType,
  DropdownSliderOption,
  DropdownSubmenu,
} from './types';

export const isDropdownOption = (
  option: DropdownItem
): option is DropdownOption => option.type === DropdownOptionType.OPTION;

export const isDropdownLink = (option: DropdownItem): option is DropdownLink =>
  option.type === DropdownOptionType.LINK;

export const isDropdownButtonOption = (
  option: DropdownItem
): option is DropdownButtonOption =>
  option.type === DropdownOptionType.BUTTON_OPTION;

export const isDropdownDivider = (
  option: DropdownItem
): option is DropdownDivider => option.type === DropdownOptionType.DIVIDER;

export const isDropdownCustomContentOption = (
  option: DropdownItem
): option is DropdownCustomContentOption =>
  option.type === DropdownOptionType.CUSTOM_CONTENT_OPTION;
export const isDropdownHeader = (
  option: DropdownItem
): option is DropdownHeader => option.type === DropdownOptionType.HEADER;

export const isDropdownHeaderWithIconButton = (
  option: DropdownItem
): option is DropdownHeaderWithIconButton =>
  option.type === DropdownOptionType.HEADER_WITH_ICON_BUTTON;

export const isDropdownMessage = (
  option: DropdownItem
): option is DropdownMessage => option.type === DropdownOptionType.MESSAGE;

export const isDropdownSubmenu = (
  option: DropdownItem
): option is DropdownSubmenu => option.type === DropdownOptionType.SUBMENU;

export const isDropdownSliderOption = (
  option: DropdownItem
): option is DropdownSliderOption => option.type === DropdownOptionType.SLIDER;

export const isDropdownExpandableSection = (
  option: DropdownItem
): option is DropdownExpandableSection =>
  option.type === DropdownOptionType.EXPANDABLE_SECTION;

export const isDropdownAiSection = (
  option: DropdownItem
): option is DropdownAiSection => option.type === DropdownOptionType.AI_SECTION;

export const isDropdownAiOption = (
  option: DropdownItem
): option is DropdownAiOption => option.type === DropdownOptionType.AI_OPTION;
